/* eslint-disable */
import { useTranslation } from 'react-i18next';

import { GenreGroupMenuBookInfoType, MenuBookGroupInfoType, MenuGroupInfoType } from 'apis/types';
import { useAppSelector } from 'app/hooks';
import MenuItemThumbnail from 'components/MenuItemThumbnail/MenuItemThumbnail';
import { MENU_TIMING_STATUS } from 'constants/menuTiming';
import { selectDisplayTimingGroupResults } from 'store/selectors/menuTimingSelectors';
import { selectAllYouCanEatState, selectThMenuInfo } from 'store/slices/allYouCanEatSlice';
import {
  selectDispcondGroup,
  selectDispcondMenu,
  selectDisplayTimingGroups,
  selectHaveAdult,
  selectHistoryFlag,
  selectMenu,
  selectOrderHistoryData,
  selectOutOfStockItems,
  selectShinagire,
  selectTenpoInfo,
  selectTimeFrameLunch,
} from 'store/slices/mainSlice';
import { selectSubGenre } from 'store/slices/menuInfoSlice';
import { selectTime } from 'store/slices/timeSlice';
import { getErrorMessage, getMenuAllYouCanEat, getTimeFrameId, SESSION_CURRENT_TIME } from 'utils';
import { attrLang } from 'utils/attrLang';
import { resolveMenuTiming } from 'utils/displayTimingGroup';
import { EOS_MESSAGE } from '../../constants';

export interface SubGenreMenuMenuProps {
  menubookId: string;
  genreId: string;
  subgenreId: string;
  genreSub?: MenuGroupInfoType[];
  currentMenubook?: MenuBookGroupInfoType;
}

function SubGenreMenu({ menubookId, genreId, subgenreId, genreSub, currentMenubook }: SubGenreMenuMenuProps) {
  const { t, i18n } = useTranslation();

  const ListOfMenuItems: JSX.Element[] = [];
  const subgenreData = useAppSelector(selectSubGenre);

  const menu = useAppSelector(selectMenu);
  const thMenuInfo = useAppSelector(selectThMenuInfo);
  const allYouCanEatState = useAppSelector(selectAllYouCanEatState);
  const outOfStockItems = useAppSelector(selectOutOfStockItems);
  const shinagire = useAppSelector(selectShinagire);
  const haveAdult = useAppSelector(selectHaveAdult);
  const historyFlag = useAppSelector(selectHistoryFlag);
  const timeServer = useAppSelector(selectTime);
  const tenpoInfo = useAppSelector(selectTenpoInfo);
  const orderHistoryData = useAppSelector(selectOrderHistoryData);
  const dispcondMenu = useAppSelector(selectDispcondMenu);
  const dispcondGroup = useAppSelector(selectDispcondGroup);
  const timeFrameLunch = useAppSelector(selectTimeFrameLunch);
  const displayTimingGroupResults = useAppSelector(selectDisplayTimingGroupResults);
  const displayTimingGroups = useAppSelector(selectDisplayTimingGroups);
  const timeFrame = getTimeFrameId(
    sessionStorage.getItem(SESSION_CURRENT_TIME) ?? timeServer.tm_hh_mm,
    tenpoInfo?.time_frame
  );
  const currentSubGenre = subgenreData[subgenreId];
  const subGenreName = attrLang(currentSubGenre, 'lang');
  let genreData: GenreGroupMenuBookInfoType[] = [];
  if (currentMenubook) {
    genreData =
      currentMenubook?.course && currentMenubook.course !== null
        ? getMenuAllYouCanEat(currentMenubook)
        : currentMenubook.genre ?? [];
  }

  genreData = genreData?.filter((item) => item.genre_id === genreId);
  if (genreSub && currentMenubook) {
    genreSub.forEach((sub) => {
      const menuItemInfo = menu[sub.poscd];
      if (menuItemInfo && genreData) {
        const timingResolution = resolveMenuTiming(
          menuItemInfo,
          displayTimingGroupResults,
          displayTimingGroups,
          i18n.language,
          t('MenuList.time_control_unavailable')
        );

        // Time Control Hidden wins over every legacy blocker: the item is not rendered at all.
        if (timingResolution.status === MENU_TIMING_STATUS.HIDDEN) return;

        const timingMessageOverlay =
          timingResolution.status === MENU_TIMING_STATUS.OVERLAY ? timingResolution.message : '';

        const outOfStocked = outOfStockItems.includes(sub.poscd);
        const isItemShinagire = shinagire.includes(sub.poscd);

        const messageOverlay = getErrorMessage(
          thMenuInfo.code,
          timeFrameLunch.includes(timeFrame.time_frame_id),
          historyFlag,
          allYouCanEatState,
          menuItemInfo,
          currentMenubook,
          outOfStocked,
          menuItemInfo.eos_flg,
          parseInt(haveAdult),
          dispcondMenu,
          dispcondGroup,
          orderHistoryData.OrderDetail,
          isItemShinagire
        );

        // issue #107 — an out-of-stock item is hidden instead of being shown with an overlay.
        const isShowMenu = messageOverlay !== EOS_MESSAGE;

        if (isShowMenu && menuItemInfo) {
          ListOfMenuItems.push(
            <MenuItemThumbnail
              key={sub.poscd}
              itemInfo={menuItemInfo}
              menubookId={menubookId}
              genreId={genreId}
              messageOverlay={messageOverlay}
              timingMessageOverlay={timingMessageOverlay}
              outOfStocked={outOfStocked}
              currentMenuBook={currentMenubook}
            />
          );
        }
      }
    });
  }

  return ListOfMenuItems.length > 0 ? (
    <div id={`subgenre-menu-${subgenreId}`} className="subgenre-menu-block">
      {subGenreName && subGenreName.length > 0 && (
        <div
          className="subgenre-name"
          data-subgenrename={subGenreName}
          dangerouslySetInnerHTML={{ __html: subGenreName }}
        ></div>
      )}
      <div className="thumbnail-block">{ListOfMenuItems}</div>
    </div>
  ) : null;
}

export default SubGenreMenu;
